<div [id]="id" class="map-container">
  @if (
    ((isFullScreenModal() && customTemplate()?.isFullScreenTemplate) ||
      (!isFullScreenModal() && !customTemplate()?.isFullScreenTemplate)) &&
    customTemplate() &&
    isMapReady()
  ) {
    <div [id]="'map-custom-element'" class="map-container__custom-template">
      <ng-container
        *ngTemplateOutlet="
          $safeNavigationMigration(customTemplate()?.template)
        "></ng-container>
    </div>
  }
  <div class="map-container__buttons-wrapper">
    @if (enableShapeDrawing()) {
      <div class="map-container__buttons-wrapper--polygon-btn">
        <dv-button
          (click)="onDrawPolygonClicked()"
          icon="shape_polygon_plus"
          [disabled]="!isMapReady()"
          text="{{ 'Map.Shape.Polygon' | translate | uppercase }}"
          color="secondary">
        </dv-button>
      </div>
      <div class="map-container__buttons-wrapper--circle-btn">
        @if (enableShapeDrawing()) {
          <dv-button
            (click)="onDrawCircleClicked()"
            icon="shape_circle_plus"
            [disabled]="!isMapReady()"
            text="{{ 'Map.Shape.Circle' | translate | uppercase }}"
            color="secondary"></dv-button>
        }
      </div>
    }
    @if (showFullScreenBtn()) {
      <button
        class="map-container__buttons-wrapper--full-screen-btn"
        (click)="openFullScreen()"
        [disabled]="!isMapReady()">
        <span class="dv-icons">open_in_new</span>
      </button>
    }
    @if (isFullScreenModal()) {
      <button
        class="map-container__buttons-wrapper--close-btn"
        (click)="close()"
        [disabled]="!isMapReady()">
        <span class="dv-icons">close</span>
      </button>
    }
  </div>
</div>
